<template>
  <div>
    <div
      class="vx-row mt-4"
      v-for="(inputField, index) in inputInstances"
      :key="inputField.id"
    >
      <additive-contact-field
        v-model="inputInstances[index]"
        :additional-input-label="additionalInputLabel"
        :additionalInput="additionalInput"
        :additionalInputValidationName="additionalInputValidationName"
        :additionalInputValidationType="additionalInputValidationType"
        :canSetPrimary="canSetPrimary"
        :dropdown-label="dropdownLabel"
        :options="options"
        :primary-select-validation-name="primarySelectValidationName"
        :primary-select-validation-type="primarySelectValidationType"
        :primary-input-validation-name="primaryInputValidationName"
        :primary-input-validation-type="primaryInputValidationType"
        :secondary-input-label="secondaryInputLabel"
        :secondary-input-validation-type="secondaryInputValidationType"
        :secondary-select-label="secondarySelectLabel"
        :secondary-select-options="secondarySelectOptions"
        :secondary-select-validation-type="secondarySelectValidationType"
        :secondaryInputValidationName="secondaryInputValidationName"
        :secondarySelectValidationName="secondarySelectValidationName"
        :validationName="validationName"
        :validationType="validationType"
        @makePrimary="makePrimary(index)"
        @remove="remove(index)"
      />
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mt-3">
        <vs-button @click="addInputField(false)">
          {{ this.buttonLabel }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdditiveContactField from './AdditiveContactField';

export default {
  name: 'AdditiveContactFields',
  inject: ['$validator'],
  components: {
    AdditiveContactField
  },
  props: {
    validationName: {
      type: String
    },
    validationType: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    },
    canSetPrimary: {
      type: Boolean,
      required: false,
      default: false
    },
    secondarySelectOptions: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    additionalInput: {
      type: Boolean,
      required: false,
      default: false
    },
    additionalInputValidationName: {
      type: String
    },
    additionalInputValidationType: {
      type: String,
      default: ''
    },
    primaryInputValidationName: {
      type: String,
      default: 'value'
    },
    primaryInputValidationType: {
      type: String,
      default: ''
    },
    primarySelectValidationName: {
      type: String,
      default: 'dropdownValue'
    },
    primarySelectValidationType: {
      type: String,
      default: ''
    },
    secondarySelectValidationName: {
      type: String
    },
    secondarySelectValidationType: {
      type: String,
      default: ''
    },
    secondaryInputValidationName: {
      type: String
    },
    secondaryInputValidationType: {
      type: String,
      default: ''
    },
    dropdownLabel: {
      type: String
    },
    secondarySelectLabel: {
      type: String
    },
    secondaryInputLabel: {
      type: String
    },
    additionalInputLabel: {
      type: String
    }
  },
  data() {
    return {
      inputInstances: [
        {
          id: '',
          dropdownValue: '',
          value: '',
          secondaryValue: '',
          primary: 1,
          dropdownValues: [],
          additionalInputValue: ''
        }
      ]
    };
  },
  computed: {},
  watch: {
    inputInstances: {
      handler(val) {
        this.$emit('value', val);
      },
      deep: true
    }
  },
  created() {
    this.inputInstances = this.value;
  },
  methods: {
    addInputField(primary = false) {
      // This is required for the validation as each field needs
      // to have a unite ID that is not the index
      let id = this.inputInstances.length + 1;

      this.inputInstances.push({
        id: id,
        dropdownValue: '',
        value: '',
        secondaryValue: '',
        primary: primary ? 1 : 0
      });
    },
    remove(index) {
      this.$delete(this.inputInstances, index);
    },
    makePrimary(index) {
      this.inputInstances.forEach((inputField, key) => {
        inputField.primary = index === key ? 1 : 0;
      });
    }
  }
};
</script>
